import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import {Col, FormGroup, Input, Label, Row} from 'reactstrap';
import _ from 'lodash';
import PropTypes from 'prop-types';
import {Validacao} from "../../comum/components/Validacao";
import Select from "react-select";
import SelectAsync from "../../comum/components/SelectAsync";
import {arrayToString, createSelectOptions, formatarReal, formatTelefone} from "../../../utils/formatar";
import NumberFormat from "react-number-format";
import {getTipoGDVById} from "../../../utils/enums";
import {LoadingBlockFields} from "../../comum/components/LoadingBlockFields";
import {Alerta} from "../../comum/components/Alerta";

@inject("store")
@observer
export class CargoForm extends Component {

    static propTypes = {
        controller: PropTypes.object
    };

    constructor(props) {
        super(props);
    }

    render() {
        const solicitacao = this.props.controller.solicitacao;
        const exibeSalarioBase = this.props.controller.exibeSalarioBase;
        const exibeSalarioExcecao = this.props.controller.exibeSalarioExcecao;
        const exibeValorAcheCargo = this.props.controller.exibeValorAcheCargo;
        const exibePercentualSalarioGlobo = this.props.controller.exibePercentualSalarioGlobo;
        const exibeGdv = this.props.controller.exibeGdv;
        const exibePericulosidade = this.props.controller.exibePericulosidade;
        const exibeInsalubridade = this.props.controller.exibeInsalubridade;
        const salarioExcecaoMin = this.props.controller.salarioExcecaoMin;
        const mensagemErroSalarioExcecao = this.props.controller.mensagemErroSalarioExcecao;
        //const obterCargoSubstituido = this.props.controller.obterCargoSubstituido;
        //const cargoNaoPresente = this.props.controller.cargoNaoPresente;
        //const salarioBase = this.props.controller.salarioBaseCargo;

        //RHFPP-2365 - Tratamento de ache p/ salario de exceção
        // Cálculo do valor do Ache para o salário de exceção
        const percentualBase = solicitacao.cargo && solicitacao.cargo.percentualAche ? (100 / (100 + solicitacao.cargo.percentualAche)) : 0;
        const salarioBaseExcecao = solicitacao.salarioExcecao && solicitacao.salarioExcecao > 0 ? (solicitacao.salarioExcecao * percentualBase) : 0;
        const valorAcheExcecao = solicitacao.salarioExcecao && solicitacao.salarioExcecao > 0 ? (solicitacao.salarioExcecao - salarioBaseExcecao) : 0;

        const desabilitaCargo = (!solicitacao.localContratacaoId || solicitacao.motivoContratacao === "SUB");

        // Cálculo do percentual em relação ao salário Globo
        const percentualSalarioGlobo = (solicitacao.cargo && solicitacao.cargo.salarioGlobo) ? 
            (solicitacao.salarioExcecao && solicitacao.salarioExcecao > 0) ? 
                (solicitacao.cargo.percentualAche ? 
                    ((salarioBaseExcecao * 100 / solicitacao.cargo.salarioGlobo).toFixed(0) + "%") :
                    ((solicitacao.salarioExcecao * 100 / solicitacao.cargo.salarioGlobo).toFixed(0) + "%")) : 
                "0%" : "0%";

        
        return (
            <LoadingBlockFields carregando={this.props.controller.carregandoCargo}>
                <div>
                    <h4>Cargo</h4>
                    <Row>
                        <Col xs={12} md={6} lg={4}>
                            <FormGroup>
                                <Label>Cargo <sup>*</sup></Label>
                                <div>
                                    <SelectAsync value={this.props.controller.cargoSelecionado}
                                            disabled={desabilitaCargo}
                                            asyncOptions={(input, callback) => {this.props.controller.filtrarCargos(input,callback);}}
                                            cacheAsyncResults={false}
                                            onChange={(value) => this.props.controller.setCargo(value)}
                                            noResultsText="Nenhum resultado encontrado"
                                            placeholder="Selecione..."
                                            autoload={false}
                                            searchPromptText="Informe nome para pesquisar" />
                                    <Validacao id="cargoId" valor={solicitacao.cargoId} tipo={["isRequired"]} />
                                </div>
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={6} lg={4}>
                            <FormGroup>
                                <Label>Categoria</Label>
                                <Input type="text" value={_.get(solicitacao.cargo, "sindicato", "")} readOnly />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={6} lg={4}>
                            <FormGroup>
                                <Label>Jornada mensal (h)</Label>
                                <Input value={_.get(solicitacao.cargo, "jornadaMensal", "")} readOnly />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <FormGroup>
                                <Label>Detalhamento do cargo</Label>
                                <Input type="textarea" value={_.get(solicitacao.cargo, "detalhamento", "")} readOnly />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        {exibeValorAcheCargo &&
                        <Col xs={12} md={6} lg={4}>
                            <FormGroup>
                                <Label>Valor salário base + Ache</Label>
                                <Input type="text" value={formatarReal(_.get(solicitacao, "cargo.salarioBase")+_.get(solicitacao, "cargo.percentualAche")*_.get(solicitacao, "cargo.salarioBase")/100)} readOnly/>
                            </FormGroup>
                        </Col>
                        }
                        {exibeSalarioBase &&
                        <Col xs={12} md={6} lg={4}>
                            <FormGroup>
                                <Label>Valor salário base</Label>
                                <Input type="text"
                                       value={_.get(solicitacao.cargo, "salarioBase", null) ? formatarReal(_.get(solicitacao.cargo, "salarioBase")) : ""}
                                       readOnly/>
                            </FormGroup>
                        </Col>
                        }
                        {exibeValorAcheCargo &&
                        <Col xs={12} md={6} lg={4}>
                            <FormGroup>
                                <Label>Valor do Ache</Label>
                                <Input type="text" value={formatarReal(_.get(solicitacao, "cargo.percentualAche")*_.get(solicitacao, "cargo.salarioBase")/100)} readOnly/>
                            </FormGroup>
                        </Col>
                        }
                        {exibeSalarioExcecao &&
                        <Col xs={12} md={6} lg={4}>
                            <FormGroup>
                                <Label>Salário de exceção <sup>*</sup></Label>
                                <div>
                                    <NumberFormat allowNegative={false} className="form-control" thousandSeparator="." decimalPrecision={2} decimalSeparator="," prefix={'R$ '} value={solicitacao.salarioExcecao} onChange={(event, values) => this.props.controller.setSalarioExcecao(values.floatValue)} onBlur={() => this.props.controller.validarCpfIndicacoes()} />
                                    <Validacao id="salarioExcecao" valor={solicitacao.salarioExcecao} tipo={["isRequired","salarioMaiorQue",salarioExcecaoMin]} mensagem={{salarioMaiorQue: mensagemErroSalarioExcecao}}/>
                                </div>
                            </FormGroup>
                        </Col>
                        }
                        {exibeSalarioExcecao && solicitacao.cargo && solicitacao.cargo.percentualAche > 0 && solicitacao.salarioExcecao > 0 && (
                        <Col xs={12} md={6} lg={4}>
                            <FormGroup>
                                <Label>Valor salário base de exceção</Label>
                                <Input type="text" value={formatarReal(salarioBaseExcecao)} readOnly/>
                            </FormGroup>
                        </Col>
                        )}
                        {exibeSalarioExcecao && solicitacao.cargo && solicitacao.cargo.percentualAche > 0 && solicitacao.salarioExcecao > 0 && (
                        <Col xs={12} md={6} lg={4}>
                            <FormGroup>
                                <Label>Valor do Ache de exceção</Label>
                                <Input type="text" value={formatarReal(valorAcheExcecao)} readOnly/>
                            </FormGroup>
                        </Col>
                        )}
                    </Row>
                    <Row>
                        {exibePercentualSalarioGlobo && solicitacao.cargo && solicitacao.cargo.salarioBase && (
                        <Col xs={12} md={6} lg={4}>
                            <FormGroup>
                                <Label>Percentual em relação salário Globo</Label>
                                <Input type="text" value={percentualSalarioGlobo} readOnly/>
                            </FormGroup>
                        </Col>
                        )}
                        {exibeInsalubridade &&
                        <Col xs={12} md={6} lg={4}>
                            <FormGroup>
                                <Label>Insalubridade <span style={{fontSize: 10}}>(sobre salário mínimo)</span></Label>
                                <Input type="text" value={_.get(solicitacao.cargo, "insalubridade", "")} readOnly/>
                            </FormGroup>
                        </Col>
                        }
                        {exibePericulosidade &&
                        <Col xs={12} md={6} lg={4}>
                            <FormGroup>
                                <Label>Periculosidade <span style={{fontSize: 10}}>(sobre salário base)</span></Label>
                                <Input type="text" value={_.get(solicitacao.cargo, "periculosidade", "")} readOnly/>
                            </FormGroup>
                        </Col>
                        }
                    </Row>
                    <Row>
                        {exibeGdv &&
                        <Col xs={12} md={6} lg={4}>
                            <FormGroup>
                                <Label>GDV {solicitacao.cargo.tipoGDV && getTipoGDVById(solicitacao.cargo.tipoGDV) ? "("+getTipoGDVById(solicitacao.cargo.tipoGDV).valor.toLowerCase()+")" : null}<span style={{fontSize: 10}}> (sobre salário base)</span></Label>
                                <NumberFormat suffix="%" maxLength={10} allowNegative={false}
                                              className="form-control" decimalPrecision={1} decimalSeparator=","
                                              value={_.get(solicitacao.cargo, "percentualGDV")}
                                              readOnly/>
                            </FormGroup>
                        </Col>
                        }
                    </Row>
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <FormGroup>
                                <Label>EPI</Label>
                                <Input type="textarea" value={this.props.controller.solicitacao.descricaoEpis} readOnly />
                            </FormGroup>
                        </Col>
                    </Row>
                </div>
            </LoadingBlockFields>
        )
    }
}